<template>
  <div class="w-full hidden lg:flex flex-row justify-center fourth-row-container">
    <div class="w-full max-w-1440 flex lg:flex-row flex-col justify-between lg:items-center">
      <!-- Left side nav links -->
      <div class="hidden lg:flex items-center space-x-6 h-full font-rubik">
        <!-- Static link for 'About' -->
        <div
          :class="['nav-link', isActive(aboutSlug) ? 'active' : '', 'flex items-center px-3 h-full']"
          :style="isActive(aboutSlug) ? { '--active-color': brandColor } : {}"
        >
          <a
            :href="aboutSlug"
            class="subheader-nav-links mt-1"
            :style="isActive(aboutSlug) ? { color: brandColor } : { color: '#0c0e20' }"
          >
            About
          </a>
        </div>
        <!-- Dynamic links from solutionsArr -->
        <div
          v-for="solution in solutionsArr"
          :key="`nav-row-solution-${solution.title}`"
          :class="['nav-link', isActive(solution.slug) ? 'active' : '', 'flex items-center px-1 h-full']"
          :style="isActive(solution.slug) ? { '--active-color': brandColor } : {}"
        >
          <a
            :href="solution.slug"
            class="subheader-nav-links"
            :style="isActive(solution.slug) ? { color: brandColor } : { color: '#0c0e20' }"
          >
            {{ solution.title }}
          </a>
        </div>
      </div>
      
      <!-- Right side Partner and City -->
      <div class="flex items-center justify-between flex-row-reverse lg:flex-row lg:space-x-4 lg:mb-1">
        <div class="flex flex-row items-center gap-3">
          <p class="bottom-section-partner-name">Partner <span>{{ organization.name }}</span></p>
          <p v-if="city && state" class="bottom-section-location flex items-center"> 
            <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
            {{ `${city}, ${state}` }}
          </p>
          <p v-else-if="organization.data['service_area']" class="bottom-section-location flex items-center"> 
            <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
            {{ organization.data['service_area'] }}
          </p>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationRow',
  
  props: {
    organization: {
      required: true,
      type: Object
    },
    solutions: {
      type: Array,
      required: true
    },
    solutionsPath: {
      type: Object,
      required: true
    },
    organizationPhone: {
      type: String,
      required: false
    },
    phoneNumber: {
      type: String,
      required: true
    },
    formatPhoneNumber: {
      type: Function,
      required: true
    },
    city: {
      type: String,
      required: false
    },
    state: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      solutionsArr: [],
      aboutSlug: '/solutions',
      keywordMappings: [
        { keyword: 'refrigerated container rentals', output: 'Refrigerated Rentals' },
        { keyword: 'refrigerated containers', output: 'Refrigerated Containers' },
        { keyword: 'container modifications', output: 'Modifications' },
        { keyword: 'portable offices', output: 'Portable Offices' },
        { keyword: 'accessories', output: 'Accessories' },
        { keyword: 'container sales', output: 'Sales' },
        { keyword: 'sales', output: 'Sales' },
        { keyword: 'rentals', output: 'Rentals' },
        { keyword: 'modifications', output: 'Modifications' },
        { keyword: 'portable', output: 'Portable Offices' },
        { keyword: 'refrigerated', output: 'Refrigerated Container' }
      ]
    }
  },

  mounted() {
    this.createSolutionsArray(this.solutions)
    if (this.currentUrl.includes('/partners/')) {
      this.aboutSlug = `/partners/${this.organization.slug}`
    } else {
      const storedSlug = localStorage.getItem('serviceAreaAboutSlug')
      this.aboutSlug = storedSlug ? JSON.parse(storedSlug) : '/solutions'
    }
  },

  computed: {
    currentUrl() {
      return window.location.pathname.replace(/\/$/, '')
    },
    brandColor() {
      return this.organization.data?.brand_color || '#4D84FF'
    }
  },

  methods: {
    createSolutionsArray(solutions) {
      this.solutionsArr = solutions.map(solution => {
        const formattedTitle = this.formatTitle(solution.title)
        const slug = this.getSolutionSlug(solution.id)
        return {
          title: formattedTitle,
          slug: slug
        }
      })
    },
    formatTitle(title) {
      const lowerTitle = title.toLowerCase()
      for (const mapping of this.keywordMappings) {
        if (lowerTitle.includes(mapping.keyword.toLowerCase())) {
          return mapping.output
        }
      }
      // Default to capitalizing the original title if no keyword matches
      return title.replace(/\b\w/g, l => l.toUpperCase())
    },
    getSolutionSlug(id) {
      return this.solutionsPath[id.toString()] || '#'
    },
    isActive(slug) {
      const currentUrl = window.location.pathname.replace(/\/$/, '')
      return currentUrl === slug.replace(/\/$/, '')
    },
    baseUrl() {
      return `/partners/${this.organization.slug}`
    }
  }
}
</script>

<style scoped>
.fourth-row-container {
  height: 44px;
}

.nav-link {
  position: relative;
}

.nav-link.active::before {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 4px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: var(--active-color, transparent);
  transition: background-color 0.3s ease;
}

.subheader-nav-links {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.0125em;
}

.subheader-nav-links:hover {
  color: #4D84FF !important;
}

.get-quote-button {
  width: 110px;
  height: 35px;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.0125em;
}

.subheader-phone {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.0125em;
}

.bottom-section-partner-name {
  font-size: 10px;
  font-weight: 400;
  line-height: 10px;
  color: #334155 !important;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    letter-spacing: -0.02em;
  }
}

.bottom-section-location {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  letter-spacing: -0.02em;
  color: #334155 !important;
}
</style>
